import { Injectable } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

import { Orientation } from 'shared/models/idt-components/idt-component.models';


@Injectable()
export class IdtSharedRenderService {

  public screenOrientation$ = new BehaviorSubject<Orientation>('landscape');

  constructor(
    private readonly eventManager: EventManager
  ) {
    this.checkCurrentScreenOrientation();
    this.eventManager.addGlobalEventListener('window', 'resize', this.checkCurrentScreenOrientation.bind(this));
  }

  public getCurrentScreenOrientation(target = window): Orientation {
    return target.innerHeight > target.innerWidth ? 'portrait' : 'landscape';
  }

  public checkCurrentScreenOrientation(): void {
    const orientation = this.getCurrentScreenOrientation();
    this.screenOrientation$.next(orientation);
  }

}
